import { IncentiveOffer, IncentiveOfferStatus } from '../types';

export const getOfferStatus = (offer: IncentiveOffer): IncentiveOfferStatus => {
  if (offer.canceledAt) {
    return IncentiveOfferStatus.CANCELED;
  }

  const now = new Date();
  const endDate = new Date(offer.endDate);

  if (endDate < now) {
    return IncentiveOfferStatus.EXPIRED;
  }

  if (offer.unitsCount.agreed === offer.unitsCount.total) {
    return IncentiveOfferStatus.ACCEPTED;
  }

  return IncentiveOfferStatus.ACTIVE;
};

export const isOfferExpired = (offer: IncentiveOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === IncentiveOfferStatus.EXPIRED;
};

export const isOfferAccepted = (offer: IncentiveOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === IncentiveOfferStatus.ACCEPTED;
};

export const isOfferActive = (offer: IncentiveOffer): boolean => {
  const status = getOfferStatus(offer);
  return status === IncentiveOfferStatus.ACTIVE;
};

/**
 * Ofertas de venta que siguen ocupando participaciones del socio para nuevas propuestas
 * (ej. máximo transferible por clase): activas en mercado y aceptadas al 100%.
 * No incluye EXPIRED.
 */
export const isOfferReservingBeneficiaryUnits = (
  offer: IncentiveOffer
): boolean => {
  const status = getOfferStatus(offer);
  return (
    status === IncentiveOfferStatus.ACTIVE ||
    status === IncentiveOfferStatus.ACCEPTED
  );
};
